import { useContext } from 'react'
import { GeneralContext } from '../../context/GeneralContext/GeneralContext'
import { Loader } from './Loader'

export function InternalLayoutLoader() {
    const { show_loading } = useContext(GeneralContext)

    return show_loading && <Loader />
}
